import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { VENDOR_CONTENT } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';

const VendorSection = () => {
  return (
    <section id="vendor-partnership" className="py-24 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
          >
            <motion.p
              className="text-brand-500 font-semibold text-sm uppercase tracking-wider mb-3"
              variants={fadeInUp}
            >
              Vendor Partnership
            </motion.p>
            <motion.h2
              className="text-3xl sm:text-4xl text-neutral-900 leading-tight mb-6"
              style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
              variants={fadeInUp}
            >
              {VENDOR_CONTENT.heading}
            </motion.h2>
            <motion.p
              className="text-neutral-600 text-lg leading-relaxed mb-8"
              style={{ fontFamily: "'Livvic', sans-serif" }}
              variants={fadeInUp}
            >
              {VENDOR_CONTENT.text}
            </motion.p>
            <motion.button
              className="inline-flex items-center space-x-2 bg-brand-500 text-white px-6 py-3 rounded-lg font-medium text-sm hover:bg-brand-600 transition-colors"
              variants={fadeInUp}
              whileHover={{ x: 5 }}
            >
              <span>{VENDOR_CONTENT.buttonText}</span>
              <ArrowRight size={16} />
            </motion.button>
          </motion.div>

          {/* Right - Benefits */}
          <motion.div
            className="space-y-4"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
          >
            {VENDOR_CONTENT.benefits.map((benefit, i) => (
              <motion.div
                key={i}
                className="flex items-center space-x-4 bg-white rounded-xl p-5 border border-neutral-100 shadow-sm"
                variants={staggerItem}
              >
                <CheckCircle size={22} className="text-brand-500 flex-shrink-0" />
                <span className="text-neutral-700 font-medium text-lg" style={{ fontFamily: "'Livvic', sans-serif" }}>{benefit}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VendorSection;